import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Route,
	RouterStateSnapshot,
	UrlSegment,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from 'src/shared/state/auth.state';

@Injectable({
	providedIn: 'root',
})
export class CallingTreeRoleGuard {
	private store = inject(Store);

	isCallingTree: Observable<boolean> = this.store.select(
		AuthState.isCallingTree
	);

	canActivate(
		_next: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<boolean> {
		return this.isCallingTree;
	}

	canLoad(_route: Route, _segments: UrlSegment[]): boolean {
		return this.store.selectSnapshot(AuthState.isCallingTree);
	}
}
